import { createApi } from '@reduxjs/toolkit/query/react';
import { newBackendAxiosBaseQuery } from '../../utils/axiosBaseQuery';
import { serializeQueryArgsWithTenant } from '../tenantCacheKey';

// Dedicated slice for the B2 archive / restore mutations on issue
// reports. These endpoints live on the new (ECS) backend at
// /admin/damage-reports/:id/{archive,restore}; the rest of the issue
// report graph (list, update, create) still lives on the legacy Lambda
// backend and stays in `issueReportApi`.
//
// Cross-slice cache invalidation isn't strictly required because the
// existing list refetch flow is fetch-on-mount, but the flow hook can
// still dispatch invalidations on the legacy slice if needed.
export const issueReportArchiveApi = createApi({
    reducerPath: 'issueReportArchiveApi',
    serializeQueryArgs: serializeQueryArgsWithTenant,
    baseQuery: newBackendAxiosBaseQuery(),
    endpoints: (builder) => ({
        archiveIssueReport: builder.mutation<void, { id: string }>({
            query: ({ id }) => ({
                url: `/damage-reports/${id}/archive`,
                method: 'POST',
            }),
        }),
        restoreIssueReport: builder.mutation<void, { id: string }>({
            query: ({ id }) => ({
                url: `/damage-reports/${id}/restore`,
                method: 'POST',
            }),
        }),
        // Master-only hard delete. Resolves to `…/admin/damage-reports/:id`:
        // REACT_APP_API_NEW_BACKEND_URL already ends in `/admin`, so the path
        // here must not repeat it.
        deleteIssueReport: builder.mutation<{ id: string, deleted: boolean }, { id: string }>({
            query: ({ id }) => ({
                url: `/damage-reports/${id}`,
                method: 'DELETE',
            }),
        }),
    }),
});

export const {
    useArchiveIssueReportMutation,
    useRestoreIssueReportMutation,
    useDeleteIssueReportMutation,
} = issueReportArchiveApi;
